import React from "react";

import taken from "../../illustrations/undraw_Taken_if77.svg";

import Typography from "@material-ui/core/Typography";

export default function NotFoundPage() {
  return (
    <React.Fragment>
      <div style={{ display: "flex", marginTop: 16, marginBottom: 12 }}>
        <img
          src={taken}
          alt={"Page Not Found"}
          style={{
            width: "40%",
            margin: "auto",
          }}
        ></img>
      </div>
      <Typography align="center" variant="h5" component="h5">
        You found Area 51!
      </Typography>
    </React.Fragment>
  );
}
